import { render } from "./DeliveryItem.vue?vue&type=template&id=bef96120&scoped=true"
import script from "./DeliveryItem.vue?vue&type=script&lang=js"
export * from "./DeliveryItem.vue?vue&type=script&lang=js"

import "./DeliveryItem.vue?vue&type=style&index=0&id=bef96120&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef96120"]])

export default __exports__